import { createFileRoute } from '@tanstack/react-router'
import { RefreshCw } from 'lucide-react'
import { useT } from '@/shared/i18n'
import { Button } from '@/shared/ui'

export const Route = createFileRoute('/kiosk/')({
  component: KioskHome,
})

function KioskHome() {
  const t = useT()
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 text-center">
      <h1 className="text-4xl font-bold">{t('kiosk.title')}</h1>
      <p className="text-muted-foreground">{t('kiosk.placeholder')}</p>
      <Button
        size="touch"
        variant="outline"
        onClick={() => {
          window.location.reload()
        }}
      >
        <RefreshCw aria-hidden />
        {t('actions.reload')}
      </Button>
    </div>
  )
}
